export interface PharmacyDetailsModel {
  PharmacyTitle: string;
  WarehouseCode: string;
  PharmacyId: number;
  UserId: number;
}